module.exports = __webpack_public_path__ + "img/MarkerNetz.f70f48d5.png";